import { PaletteMode } from "@mui/material";
import { esES } from "@mui/x-date-pickers";

export const darkTheme = (mode: PaletteMode) => ({
    esES,
    typography: {
      fontFamily: [
        "Poppins",
        "Roboto",
        "Helvetica",
        "Arial",
        "sans-serif",
      ].join(","),
    },
    palette: {
      mode,
      ...(mode === "light"
        ? {
            background: {
              default: "#fafafa",
            },
            primary: {
              main: "#801313",
            },
            text: {
              primary: "#3b3e66",
            },
          }
        : {}),
    },
  });